import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acceptCommunityRequest, cancelCommunityRequest, getCommunityRequests } from '../../../actions/userActions';

import AdminZoneRequest from '../../../containers/Zones/Admin/AdminZoneRequest';



const ZoneRequest = ({match}) => {
    const {communityRequests} = useSelector(state=>state.userInfo)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getCommunityRequests(match.params.zoneId))
    
      return () => {
        
      };
    }, [match.params.zoneId]);
    const accept = (id)=>{
      dispatch(acceptCommunityRequest(id))

    }
    const reject = (id)=>{
      dispatch(cancelCommunityRequest(id))
    }
    
  return <AdminZoneRequest requests={communityRequests} accept={accept} reject={reject}/>
};

export default ZoneRequest;
